import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  itemContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  itemIcon: {
    height: 18,
    marginRight: 10
  },
  itemLabel: {

  }
});
